// show tags the most recent tags

export default tags =>
  tags
    .sort((a, b) => b.time - a.time)
    .filter(t => t.tag[0] !== '_')
    .filter((t, i) => i === 0)
